module.exports = __webpack_public_path__ + "img/zi-xhd.c55c70f5.png";